import { createActions } from '../utils/actions';

const { actions: studioVideos } = createActions('studio.videos')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('createFolder')
  .addAsync('deleteFolder')
  .addAsync('deleteItems')
  .addAsync('downloadItems')
  .addAsync('getFolders')
  .addAsync('getItems')
  .addAsync('moveItems')
  .addAsync('renameFolder')
  .add('setValue')
  .add('toggleItemState')
  .addAsync('uploadFiles');

export default studioVideos;
